__turbopack_context__.v({
  "alert": "CompetitionRegistrationModal-module__lPLabq__alert",
  "body": "CompetitionRegistrationModal-module__lPLabq__body",
  "dialog": "CompetitionRegistrationModal-module__lPLabq__dialog",
});
